import React from 'react';
import cn from 'classnames';

import { BettingWidgets } from 'app-constants';
import { useWidgetSettings } from 'hooks';
import { ViewerMode } from '../../constants';
import StreamHeader from '../StreamHeader';
import StreamPlayer from '../StreamPlayer';
import usePersistentStream from './usePersistentStream';

import './persistentStream.scss';

interface Props {}

const PersistentStream: React.FC<Props> = () => {
    const {
        viewerMode,
        pinnedStreamUrl,
        pinnedStreamTitle,
        onToggleStreamFullscreen,
        onStreamUnpin,
        onTogglePlayStatus,
        isHiddenFullScreenBtn,
    } = usePersistentStream();

    const { disableTheaterMode } = useWidgetSettings({
        widget: BettingWidgets.STREAM,
    });

    if (!pinnedStreamUrl || viewerMode !== ViewerMode.STREAM) return null;

    return (
        <div
            styleName={cn('container', {
                'is-hidden-full-screen-btn': isHiddenFullScreenBtn,
            })}
            className="__app-PersistentStream-container"
        >
            <StreamHeader
                disableTheaterMode={disableTheaterMode}
                isValidSportId={false}
                betradarId={null}
                url={pinnedStreamUrl}
                viewerMode={viewerMode}
                isPinned={true}
                isFullscreenActive={false}
                onToggleStreamFullscreen={onToggleStreamFullscreen}
                onStreamUnpin={onStreamUnpin}
                title={pinnedStreamTitle || ''}
                hasMatchLog={false}
            />
            <StreamPlayer
                togglePlayStatus={onTogglePlayStatus}
                url={pinnedStreamUrl}
                autoplay={true}
                playerNodeId="persistent-stream"
            />
        </div>
    );
};

export default PersistentStream;
